import { CalendarIcon } from 'lucide-react-native';
import type { FieldValues } from 'react-hook-form';

import { formatTextInputAsDate } from '../../utils/dateUtils';
import { ControlledInput, type ControlledInputProps } from './ControlledInput';

// TODO: Remove this component and use ControlledDateInput instead?
export interface ControlledDateTextInputProps<
    TFieldValues extends FieldValues,
    TContext,
> extends ControlledInputProps<TFieldValues, TContext> {}

export const ControlledDateTextInput = <
    TFieldValues extends FieldValues,
    TContext,
>({
    ...props
}: ControlledDateTextInputProps<TFieldValues, TContext>) => {
    return (
        <ControlledInput<TFieldValues, TContext>
            placeholder="MM/DD/YYYY"
            keyboardType="number-pad"
            enterKeyHint="done"
            maxLength={10}
            formatValueOnChange={formatTextInputAsDate}
            rightIcon={CalendarIcon}
            {...props}
        />
    );
};
